<script>
    import Footer from '../landing_page/footer.svelte';
    import HeaderProgramSection from './header_program_section.svelte';
    import SliderRightMbl from './mobile_reuse-section/slider_right_mbl.svelte';
    const list = [
        {
            count: 'i',
            heading: 'Hero Mindset',
            description: 'Have a vision for the future to work on',
        },
        {
            count: 'ii',
            heading: 'Startup 101 ',
            description: 'Should have a business plan by the end',
        },
        {
            count: 'iii',
            heading: 'Futurism ',
            description: 'Have a clear understanding of emerging technologies',
        },
        {
            count: 'iv',
            heading: 'Investment ',
            description: 'Access leading investors in our network',
        },
    ];
    const fundamentalCurriculum = [
        {
            img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15499.svg',
            img_width: '4.692vw',
            title: 'Develop Your Business',
            text: 'Learn how to develop your business from Silicon Valley Founders and Experts',
        },
        {
            img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15500.svg',
            img_width: '4.696vw',
            title: 'Online Activities',
            text:
                'The Program is delivered through online lectures by Silicon Valley Experts ' +
                'and Founders, and through group live activities around challenges',
        },
        {
            img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15501.svg',
            img_width: '4.167vw',
            title: '1:1 Mentoring',
            text:
                '5 Sessions of 1-1 Mentoring with Worldwide industry experts, mentors and  ' +
                ' investors committed to supporting you on your entrepreneurial journey',
        },
        {
            img: '/images/fundamental_programs/FOE_Curicullum_Icons/Group 15502.svg',
            img_width: '4.101vw',
            title: '$100,000 Funding',
            text:
                'Draper University has a fund dedicated to investing  ' +
                ' up to $100,000 in chosen alumni companies of this program',
        },
    ];
    import {
        fundamental,
        sliderFromRight,
    } from './program_data.js';
    import {
        sliderRightMbl,
        fundamentalCurriculumMbl,
    } from './mobile_reuse-section/mobile_reuse_section_data';
    import SliderFromRight from './slider_from_right.svelte';
    import CurriculumMblFundamental from './mobile_reuse-section/curriculum_mbl_fundamental.svelte';
    const {title} = rpcjs.props;
    title.set('Fundamental | Program');
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), 'event': 'gtm.js'});
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <!--Header Section-->

    <HeaderProgramSection
        data={fundamental}
        marginTop="2.5vw"
        lineHeightMbl="11.111vw"
        TopMbl="95.5vw"
        colors="white"
        textWidth="62.5vw"
        headingTop="-8.4vw"
        headingLeft="0.135vw"
        textWidthMbl="-1vw"
        discTop="37vw"
    />
    <div class="desktop">
        <div
            style="display: flex;align-items:center;margin-left: 5.886vw;margin-top: 10.317vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:3.241vw; opacity:0.3;
                margin-top:0.6vw;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                Alumni Success Stories
            </h1>
        </div>
        <!--Slider-->
        <SliderFromRight data={sliderFromRight} />
        <div
            style="display: flex;align-items:center;margin-left: 5.886vw;margin-top: 3.921vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:1.191vw;margin-right:3.241vw; opacity:0.3;margin-top: 0.6vw;"
            >
                02
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
            >
                DUV Companies
            </h1>
        </div>
        <div style="margin-left: 10.5vw;">
            <p
                class="section2-text"
                style="font-size: 1.323vw; width:28.836vw;padding-top: 0.95vw; "
            >
                DraperU Ventures has invested in 58+ alumni companies in the
                last three years
            </p>
        </div>
        <div
            style="width: 72.718vw;
            margin-top: 4.034vw;
            margin-left: 12.463vw;"
        >
            <img
                alt=""
                src="/images/Hero_section/group_company.png"
                width="100%"
            />
        </div>

        <div style="position: relative;">
            <div class="circle" />
            <div class="circle" />
            <div class="circle" />
        </div>
        <div class="desktop">
            <div style="width: 88.815vw;margin:9.243vw  auto;padding:0 1vw;">
                <div style="display: flex;align-items:center">
                    <h1
                        class="section1"
                        style="color:rgba(0, 32, 75, 1);font-size:1.191vw;margin-right:3.241vw;opacity:0.3;
                        margin-top:0.6vw;"
                    >
                        03
                    </h1>
                    <h1
                        class="section-title"
                        style="color:rgba(0, 32, 75, 1);font-size:2.068vw;text-transform: uppercase;"
                    >
                        Curriculum Highlights
                    </h1>
                </div>
                <div
                    style="border-radius:1.2vw;box-shadow: 0vw 0.265vw 2.912vw rgba(0, 32, 75, 0.2);margin-top:5vw;"
                >
                    {#each fundamentalCurriculum as curriculumText}
                        <div class="content-holder">
                            <div
                                style="display: inline-flex;align-items: center;width:100%"
                            >
                                <div
                                    class="img-wrraper-logo"
                                    style="width: {curriculumText.img_width};
                                    margin-right: 7.664vw;
                                    height: 11.5vw;
                                    margin-left: 4vw;
                                    display: flex;"
                                >
                                    <img
                                        src={curriculumText.img}
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    style="    margin-top: auto; margin-bottom: auto;"
                                >
                                    <div>
                                        <h1
                                            class="section1list"
                                            style="font-size: 1.985vw;font-weight: 600;"
                                        >
                                            {curriculumText.title}
                                        </h1>
                                    </div>
                                    <div
                                        style="color:#00204B; font-size: 1.190vw; width:62.835vw;padding-top: 0.45vw"
                                    >
                                        <p>
                                            {curriculumText.text}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div style="display: flex;">
                <div style="align-items:center">
                    <h1
                        class="section1"
                        style="color:rgba(0, 32, 75, 1);font-size:1.191vw;margin-top: 2.15vw;margin-left: 5.886vw;opacity:0.3;"
                    >
                        04
                    </h1>
                </div>
                <div class="recipent-img">
                    <img
                        src="/images/fundamental_programs/recipent_invite.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-top: 8.577vw;margin-left: 1.579vw;">
                    <div class="recipent-head">
                        <p>BADGE OF HONOR</p>
                    </div>
                    <div
                        class="recipent-text"
                        style="font-size: 1.190vw;color: #012453;
                    width: 24.942vw;padding-top: 0.55vw;"
                    >
                        <p>
                            Earn a digital Draper University certificate upon
                            admission and successful completion of the program.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div
            style="background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 99.35%);padding:1vw;margin-top: 9.524vw;
            margin-bottom: -0.2vw;"
        >
            <div
                style="display: flex;align-items:center; margin-left:4vw; margin-top:5.540vw;"
            >
                <h1
                    class="section1"
                    style="color:white;font-size:1.191vw;margin-right:10.317vw; opacity:0.6;
                    margin-top:0.6vw;"
                >
                    05
                </h1>
                <h1
                    class="section-title"
                    style="color:white;font-size:2.068vw;text-transform: uppercase;"
                >
                    Why Join this Program
                </h1>
            </div>
            <div class="footer-img">
                <img
                    src="/images/fundamental_programs/footer_img.png"
                    alt=""
                    width="100%"
                />
            </div>
            <div
                style="display: flex;margin-left: 17.048vw;margin-top:7.003vw;
            width: 50vw;
            justify-content: space-between;"
            >
                <div style="display: flex;align-items: baseline;">
                    <div
                        style="width: 2vw;
                    text-align: end;"
                    >
                        <p class="footer-count">i</p>
                    </div>
                    <div style="margin-left: 3.5vw;">
                        <p class="footer-head">Hero Mindset</p>
                        <p class="footer-text">
                            Have a vision for the future to work on
                        </p>
                    </div>
                </div>
                <div style="display: flex; margin-left:6.474vw;">
                    <div
                        style="width: 2vw;
                    text-align: end;"
                    >
                        <p class="footer-count">ii</p>
                    </div>
                    <div style="margin-left: 3.2vw;">
                        <p class="footer-head">Futurism</p>
                        <p class="footer-text" style="line-height: 1.653vw;">
                            Have a clear understanding of emerging technologies
                        </p>
                    </div>
                </div>
            </div>
            <div
                style="display: flex;margin-left: 17.048vw;margin-top: 2.145vw;;
                width: 50vw;
                justify-content: space-between;"
            >
                <div style="display: flex;align-items: baseline;">
                    <div
                        style="width: 2vw;
                    text-align: end;"
                    >
                        <p class="footer-count">iii</p>
                    </div>
                    <div style="margin-left: 2.646vw;">
                        <p class="footer-head">Startup 101</p>
                        <p class="footer-text">
                            Should have a business plan by the end
                        </p>
                    </div>
                </div>
                <div style="display: flex; margin-left:7.35vw;">
                    <div
                        style="width: 2vw;
                    text-align: end;"
                    >
                        <p class="footer-count">iv</p>
                    </div>
                    <div style="margin-left: 2.646vw;">
                        <p class="footer-head">Investment</p>
                        <p class="footer-text">
                            Access leading investors in our network
                        </p>
                    </div>
                </div>
            </div>
            <div
                style="    text-align: center;
            margin-top: 5vw;
            margin-left: 1.6vw;
            margin-bottom: 1.85vw;"
            >
                <button
                    class="btn-css"
                    on:click={() => (location.href = '/applyProgram')}
                >
                    APPLY NOW
                </button>
            </div>
        </div>
    </div>
    <!--Mobile Design Slider-->
    <div class="mobile">
        <div
            style="display: flex;align-items:center; margin-left:5.556vw;margin-top: 24.766vw; margin-bottom: 5vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top: 0.7vw;"
            >
                01
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Alumni Success Stories
            </h1>
        </div>
        <SliderRightMbl sliderRight={sliderRightMbl} />
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: -8vw;
            margin-bottom: 13.168vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;    margin-top: 5vw;"
            >
                02
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;margin-top: 22vw;"
                >
                    DUV Companies
                </h1>
                <p
                    style="width:74.778vw; font-size:3.056vw; line-height:6.111vw;"
                >
                    DraperU Ventures has invested in 58+ alumni companies in the
                    last three years
                </p>
            </div>
        </div>
        <div style="width: 89.722vw;margin: auto;">
            <img
                src="/images/fundamental_programs/Logo_mbl.png"
                alt=""
                width="100%"
            />
        </div>
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 20.834vw; margin-bottom: 9.276vw; "
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
            >
                03
            </h1>
            <h1
                class="section-title"
                style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
            >
                Curriculum Highlights
            </h1>
        </div>
        <CurriculumMblFundamental curriculumMbl={fundamentalCurriculumMbl} />
        <div
            style="display: flex;align-items:center; margin-left:5.556vw; margin-top: -6vw;"
        >
            <h1
                class="section1"
                style="color:#00204B;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;margin-top:3.2vw;"
            >
                04
            </h1>
            <div>
                <h1
                    class="section-title"
                    style="color:rgba(0, 32, 75, 1);font-size:5.556vw;font-weight:600;    margin-bottom: 2.589vw;
                     text-transform: uppercase;margin-top: 22vw;"
                >
                    Badge of honor
                </h1>
                <p
                    style="width:75.833vw; font-size:3.056vw;     line-height: 4.444vw;color: #00204B;    margin-bottom: 4.783vw;"
                >
                    Earn a digital Draper University certificate upon admission
                    and successful completion of the program.
                </p>
            </div>
        </div>
        <div class="recipent-img_mbl">
            <img
                src="/images/fundamental_programs/recipent_invite.svg"
                alt=""
                width="100%"
            />
        </div>
        <div
            style=" background: linear-gradient(1.05deg, #00204B 50.19%, #00429B 99.35%);padding:1vw;margin-top: 5vw;"
        >
            <div class="footer-img_mbl">
                <img
                    src="/images/fundamental_programs/footer_img.png"
                    alt=""
                    width="100%"
                />
            </div>
            <div
                style="display: flex;align-items:center; margin-left:5.556vw; margin-top: 11.942vw; margin-bottom: 12.220vw; "
            >
                <h1
                    class="section1"
                    style="color:white;font-size:2.778vw;margin-right:7.061vw; opacity:0.3;"
                >
                    05
                </h1>
                <h1
                    class="section-title"
                    style="color:white;font-size:5.556vw;font-weight:600; text-transform: uppercase;text-align: center;"
                >
                    Why Join this Program
                </h1>
            </div>

            <div style="    margin-left: 11.393vw;">
                {#each list as data}
                    <div style="display: flex;">
                        <div
                            style="width: 5vw; text-align:end;margin-right: 6.699vw;
                    margin-top: -0.5vw;"
                        >
                            <p
                                style="font-size:5.537vw; font-weight:700;color:#C7E6FF;"
                            >
                                {data.count}
                            </p>
                        </div>
                        <div style="margin-bottom: 9.687vw;">
                            <h1
                                style="color:white;font-size:5.556vw; font-weight:500;"
                            >
                                {data.heading}
                            </h1>
                            <p
                                style="color:white;font-size:3.056vw; width:57.667vw;margin-top:2vw;margin:0;"
                            >
                                {data.description}
                            </p>
                        </div>
                    </div>
                {/each}
            </div>
            <div style="margin-top: 2vw;">
                <button
                    class="yellow_btn"
                    style="padding: 1vw 12vw;margin-left: 32.5vw;"
                    on:click={() => (location.href = '/applyProgram')}
                    >Apply</button
                >
            </div>
        </div>
    </div>
    <Footer />
</section>

<style>
    /*Header Section*/
    section {
        font-family: "inter";
    }
    .btn-css {
        background-color: #f7e05f;
        border-radius: 1.984vw;
        color: #00204b;
        font-weight: 500;
        border: none;
        width: 13.228vw;
        height: 3.638vw;
        font-size: 0.926vw;
    }
    .btn-css:hover {
        background-color: transparent;
        border: 0.194vw solid white;
        color: white;
        width: 13.228vw;
        height: 3.638vw;
        font-weight: 500;
        font-size: 0.926vw;
    }
    .content-holder {
        height: 11.772vw;
    }
    .content-holder:nth-child(odd) {
        background-color: rgba(226, 242, 255, 1);
    }
    .content-holder:nth-child(1) {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }
    .circle {
        height: 24.818vw;
        width: 24.818vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -18.6vw;
        background-color: rgba(60, 136, 195, 0.33);
        top: 2.5vw;
    }
    .circle:nth-child(2) {
        top: 14vw;
        z-index: -1;
    }
    .circle:nth-child(3) {
        top: 24.2vw;
        z-index: -1;
    }
    .recipent-img {
        width: 48.743vw;
        margin-left: 5.556vw;
    }
    .recipent-head {
        font-size: 2.067vw;
        font-weight: 500;
        color: #012453;
        font-family: "Manrope";
    }
    .footer-img {
        width: 37.963vw;
        margin-left: 11.873vw;
        margin-top: 1.45vw;
    }
    .footer-count {
        font-weight: bold;
        font-size: 1.7vw;
        font-family: "inter";
        color: #88bce5;
    }
    .footer-head {
        font-size: 1.653vw;
        font-weight: 500;
        font-family: "inter";
        color: white;
    }
    .footer-text {
        font-size: 1.323vw;
        font-weight: 500;
        font-family: "inter";
        width: 25.86vw;
        margin-top: 1vw;
        color: white;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .yellow_btn {
            background: #f7e05f;
            font-size: 3.056vw;
            border-radius: 8.333vw;
            padding: 1vw 6vw;
            border: none;
        }
    }
    .recipent-img_mbl {
        width: 73.333vw;
        margin: auto;
        margin-bottom: 33.611vw;
    }
    .footer-img_mbl {
        width: 70.278vw;
        margin: auto;
        margin-top: -21vw;
    }
</style>
